import React from 'react';
import PropTypes from 'prop-types';

import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';
import {
    getAddressFieldLabelsByCountry,
    getAddressFieldPlaceholdersByCountry,
} from '../../../commons/CountryUtils';
import { validateAndRequiredZipCodeUtil } from '../../../commons/utils';
import { ADDRESS_PLACEHOLDER } from '../../../commons/Constants';

/**
 * Reusable address fields section component.
 * Used by both wire transfer and mail cheque payment sections.
 *
 * @param {string} fieldName - The field name (e.g., 'consultantInvoiceWireTransferDetails.beneficiaryAddress' or 'consultantInvoiceChequeDetails.beneficiaryAddress')
 * @param {string} consultantCountry - The consultant's country code
 */
const AddressFieldsSection = ({ fieldName, consultantCountry }) => {
    const labels = getAddressFieldLabelsByCountry(consultantCountry);
    const placeholders =
        getAddressFieldPlaceholdersByCountry(consultantCountry);

    return (
        <>
            <GenericTextInputField
                name={`${fieldName}.address`}
                label="Address"
                placeholder={ADDRESS_PLACEHOLDER}
                type="text"
                required={true}
            />

            <div className="md:flex">
                <div className="md:w-1/2 md:pr-1">
                    <GenericTextInputField
                        name={`${fieldName}.city`}
                        label={labels.city}
                        placeholder={placeholders.city}
                        type="text"
                        required={true}
                    />
                </div>
                <div className="md:w-1/2 md:pl-1">
                    <GenericTextInputField
                        name={`${fieldName}.state`}
                        label={labels.state}
                        placeholder={placeholders.state}
                        type="text"
                        required={true}
                    />
                </div>
            </div>

            <div className="md:flex">
                <div className="md:w-1/2 md:pr-1">
                    <GenericSelectInputField
                        name={`${fieldName}.country`}
                        label="Country"
                        options={[
                            {
                                key: consultantCountry,
                                value: consultantCountry,
                                label: labels.name,
                            },
                        ]}
                        required={true}
                        disabled={true}
                    />
                </div>
                <div className="md:w-1/2 md:pl-1">
                    <GenericTextInputField
                        name={`${fieldName}.zipCode`}
                        label={labels.zipCode}
                        placeholder={placeholders.zipCode}
                        type="text"
                        validateAndRequiredZipCodeUtil={(val) =>
                            validateAndRequiredZipCodeUtil(
                                val,
                                consultantCountry
                            )
                        }
                    />
                </div>
            </div>
        </>
    );
};

AddressFieldsSection.propTypes = {
    fieldName: PropTypes.string.isRequired,
    consultantCountry: PropTypes.string.isRequired,
};

export default AddressFieldsSection;
